// --------------------------------------------------------------
// Base
// --------------------------------------------------------------

export const ELEMENT_MAIN = 'bozena-nemcova';
export const BASE_FONT = 'Open Sans';
export const LOCALHOST = location.href.indexOf('.templates') !== -1;
export const PROGRESS_LENGTH = 8;
export const END_STEPS = 34;

export const EASE = {
  SCROLL: 0.07,
  SCENES: 0.03,
};

// --------------------------------------------------------------
// Events
// --------------------------------------------------------------

export const EVENT = {
  STATE: {
    SPEECH_DONE: 'SPEECH_DONE',
  },
};

// --------------------------------------------------------------
// Features
// --------------------------------------------------------------

export const IS_IOS = /iPad|iPhone|iPod/.test(navigator.platform);
export const IS_ANDROID = navigator.userAgent.toLowerCase().indexOf('android') > -1;
export const IS_MOBILE = IS_IOS || IS_ANDROID;
export const IS_SAFARI =
  !IS_MOBILE &&
  navigator.userAgent.toLowerCase().indexOf('safari') !== -1 &&
  navigator.userAgent.toLowerCase().indexOf('chrome') === -1;

// --------------------------------------------------------------
// Paths
// --------------------------------------------------------------

const DATA_PACKAGE_NAME = 'bozena-nemcova-data';

export const PATH = {
  IMAGE: LOCALHOST ? `../../${DATA_PACKAGE_NAME}/img/` : '/cms/bozena-nemcova-data/img/',
  SOUND: LOCALHOST ? `../../${DATA_PACKAGE_NAME}/snd/` : '/cms/bozena-nemcova-data/snd/',
};

// --------------------------------------------------------------
// Colors
// --------------------------------------------------------------

export const COLOR = {
  BG_CANVAS: 0xffffff,
};

// --------------------------------------------------------------
// Size
// --------------------------------------------------------------

export const SIZE = {
  W: 1600,
  H: 900,
  SCROLL: 15000,
};

// ------------------------------------------------------------
// Types
// ------------------------------------------------------------
export interface MainSignals {
  stateCall: signals.Signal;
  resizeCall: signals.Signal;
  tickCall: signals.Signal;
  moveCall: signals.Signal;
}

export interface MoveCallData {
  x: number;
  y: number;
}

export interface TickCallData {
  ms: number;
  scroll: number;
}

// ------------------------------------------------------------
// Assets
// ------------------------------------------------------------

export const IMAGES = {
  BG_0: '0-bg.jpg',
  OVERLAY_0: '0-overlay.png',

  BG_1: '1-bg.jpg',
  BG_2: '2-bg.jpg',

  OVERLAY_3: '3-overlay.png',
  BG_3: '3-bg.jpg',

  BG_4: '4-bg.jpg',
  BG_5: '5-bg.jpg',
  BG_6: '6-bg.jpg',
};
